module.exports = __webpack_public_path__ + "img/hovered-layer5.d87fb349.png";